import { useTranslation } from 'react-i18next'

interface Props {
  value: string[]
  onChange: (next: string[]) => void
  options: string[]
  max?: number
  disabled?: boolean
  className?: string
}

export default function SellerCitiesPicker({
  value,
  onChange,
  options,
  max = 5,
  disabled = false,
  className = '',
}: Props) {
  const { t } = useTranslation()
  const available = options.filter((city) => !value.includes(city))

  function addCity(city: string) {
    if (!city || value.includes(city) || value.length >= max) return
    onChange([...value, city])
  }

  function removeCity(city: string) {
    onChange(value.filter((item) => item !== city))
  }

  return (
    <div className={`seller-cities-picker${className ? ` ${className}` : ''}`}>
      <p className="seller-cities-picker__label">{t('account.sellerCitiesLabel')}</p>
      <p className="seller-cities-picker__hint">{t('account.sellerCitiesHint', { max })}</p>
      {value.length > 0 ? (
        <ul className="seller-cities-picker__chips">
          {value.map((city) => (
            <li key={city}>
              <span className="seller-cities-chip">
                {city}
                {!disabled ? (
                  <button
                    type="button"
                    className="seller-cities-chip__remove"
                    onClick={() => removeCity(city)}
                    aria-label={t('account.sellerCityRemove', { city })}
                  >
                    ×
                  </button>
                ) : null}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="seller-cities-picker__empty">{t('account.sellerCitiesEmpty')}</p>
      )}
      {!disabled && value.length < max && available.length > 0 ? (
        <div className="seller-cities-picker__add">
          <select
            className="seller-cities-picker__select"
            value=""
            aria-label={t('account.sellerCityAdd')}
            onChange={(e) => {
              addCity(e.target.value)
              e.target.value = ''
            }}
          >
            <option value="">{t('account.sellerCityAdd')}</option>
            {available.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
      ) : null}
    </div>
  )
}
